import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const GEO_DATA_SIDENAV_LINK = new InjectionToken<void>("GEO_DATA_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "geo-data",
        icon: "tree-structure",
        label: "SETTINGS.ITEMS.GEO_DATA",
        items: [
          {
            id: "geo-countries",
            label: "SETTINGS.ITEMS.GEO_COUNTRIES",
            routerLink: "/settings/geo-countries",
            permissions: COMMON_GUARD_OPTIONS.GEO_COUNTRY.VIEW.permissions,
          },
          {
            id: "geo-cities",
            label: "SETTINGS.ITEMS.GEO_CITIES",
            routerLink: "/settings/geo-cities",
            permissions: COMMON_GUARD_OPTIONS.GEO_CITY.VIEW.permissions,
          },
          {
            id: "geo-provinces",
            label: "SETTINGS.ITEMS.GEO_PROVINCES",
            routerLink: "/settings/geo-provinces",
            permissions: COMMON_GUARD_OPTIONS.GEO_PROVINCE.VIEW.permissions,
          },
          {
            id: "geo-caps",
            label: "SETTINGS.ITEMS.GEO_CAPS",
            routerLink: "/settings/geo-caps",
            permissions: COMMON_GUARD_OPTIONS.GEO_CAP.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
